<template>
	<div class="upload-video">
		<el-upload
			class="upload-demo"
			drag
			accept=".mp4,.avi"
			:action="uploadUrl"
		  :limit = "limit"
			:before-upload="beforeUpload"
			:on-success="(res,fileList)=>handleSuccess(res,fileList)"
			multiple>
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">将视频拖到此处，或<em>点击上传视频</em></div>
			<div class="el-upload__tip" slot="tip">上传说明：目前支持mp4、avi格式，单个视频大小需在500MB以内</div>
		</el-upload>
	</div>
</template>

<script>
	import { post, config, ajaxParam } from '@/units/request.js'
	export default {
		name: 'uploadImg',
		components: {},
		data() {
			return {
				dialogImageUrl: '',
				dialogVisible: false,
				limit:1,
				uploadUrl: ''
			}
		},
		created(){
			this.uploadUrl = config.baseUrl + 'v1/upload/pic'
		},
		methods: {
			//上传视频前验证
			beforeUpload(file){
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
				const whiteList = ['mp4', 'avi']
				if (whiteList.indexOf(fileSuffix) == -1) {
					this.$message.error("请上传正确的视频格式")
					return false
				}
			},
			//上传附件成功
			handleSuccess(res){
				console.log(res)
				this.$emit('uploadSuccess',{
					videoUrl: res.entity.fileUrl
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.upload-img{
		margin-bottom: 20px;
	}
	.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}
		.avatar-uploader .el-upload:hover {
			border-color: #409EFF;
		}
		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 178px;
			height: 178px;
			line-height: 178px;
			text-align: center;
		}
		.avatar {
			width: 178px;
			height: 178px;
			display: block;
		}
</style>
